import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup } from '@angular/forms';
import { SelectFilterV2Component } from 'src/app/components/common/select-filter-v2/select-filter-v2.component';
import { CommunicationConfigurationEmailSenderSummaryFindAllService } from '../../service/communicationConfigurationEmailSenderSummaryFindAll.service';
import { Sort, Order, UrlParameter } from 'src/app/shared/utils/url.builder';
import { SelectElementV2 } from 'src/app/components/common/select/selectElementV2';
import { CommunicationConfigurationEmailSenderSummaryModel } from '../../entity/communicationConfigurationEmailSenderSummary.model';

@Component({
  selector: 'app-communication-configuration-email-sender-select',
  standalone: true,
  imports: [CommonModule, SelectFilterV2Component],
  templateUrl: './communication-configuration-email-sender-select.component.html',
  providers: [CommunicationConfigurationEmailSenderSummaryFindAllService]
})
export class CommunicationConfigurationEmailSenderSelectComponent implements OnInit, OnChanges {
  @Input() parentFormGroup: FormGroup;
  @Input() parentFormControlName: string;
  @Input() parameters: UrlParameter[] = [];
  @Input() sort: Sort = new Sort('label', Order.ASCENDING);

  @Output() singleSelectionChangeEvent = new EventEmitter<CommunicationConfigurationEmailSenderSummaryModel>();
  @Output() elementsLoadedEvent = new EventEmitter<CommunicationConfigurationEmailSenderSummaryModel[]>();

  elements: SelectElementV2<CommunicationConfigurationEmailSenderSummaryModel>[] = [];

  constructor(public findAllService: CommunicationConfigurationEmailSenderSummaryFindAllService) {}

  ngOnInit(): void {
    this.refresh();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes['parameters'] && changes['parameters'].firstChange) || changes['sort']) {
      this.refresh();
    }
  }

  refresh(): void {
    this.elements = [];
    this.findAllService.parameters = this.parameters;
    this.findAllService.sort = this.sort;
    this.findAllService.findAll().then(values => {
      if (values) {
        this.elementsLoadedEvent.emit(values);
        this.elements = values.map(value => ({
          value: value.id,
          label: value.label,
          element: value
        }));
      }
    });
  }
}